import type { ApiSchemas } from "@/shared/api/schema";

// Tab types
export const TABS = ["all", "catalog", "sellers"] as const;
export type Tab = (typeof TABS)[number];

// Search config constants
export const SEARCH_CONFIG = {
  DEBOUNCE_MS: 300,
  MIN_QUERY_LENGTH: 1,
  DEFAULT_LIMIT: 20,
  MAX_RESULTS_PER_PAGE: 50,
} as const;

// Search result type
export type SearchResult = NonNullable<
  ApiSchemas["SearchResultsResponse"]["results"]
>[number];

// Component props
export type SearchDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showTrigger?: boolean;
  scrollOffset?: number;
  onScrollOffsetChange?: (offset: number) => void;
};
